var React = require('react');

function ArrowRightWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0h3.149l3.662 7.498L3.149 15h-3.15l3.662-7.502L0 0Z","fill":"#fff"}));
}

ArrowRightWhite.defaultProps = {"width":"7","height":"15","fill":"none"};

module.exports = ArrowRightWhite;

ArrowRightWhite.default = ArrowRightWhite;
